<template>
    <div class="notifications">
        <button type="button" class="btn mr-2 btn-notification" @click="toggleNotifications()">
            <font-awesome-icon icon="bell"/>
            <div class="badge badge-primary" v-if="count !== 0">{{count}}</div>
        </button>
        <div class="notifications-backdrop" @click="hideNotifications()" v-if="opened === true"></div>
        <div class="notifications-content" v-if="opened === true">
            <div class="notifications-header">
                <font-awesome-icon icon="bell"/>
                {{t('Notifications')}}
                <loading class="notification-loading-small"
                         size="xxs"
                         v-if="loading === true && firstLoading !== true"
                />
            </div>
            <div class="notification-loading" v-if="firstLoading === true">
                <loading size="xs"/>
            </div>
            <ul class="notifications-list" v-if="firstLoading === false">
                <li class="text-center" v-if="notifications.length === 0">
                    {{t('You do not have any notifications')}}
                </li>
                <li v-for="notification in notifications" @click="open(notification)" class="c-pointer">
                    <div class="notifications-list-item d-block">{{notification.text}}</div>
                    <small class="badge-pill badge-success"
                           v-if="notification.seenOn === null"
                    >{{t('New')}}</small>
                    <small class="date">{{notification.createdOn | dateTime}}</small>
                </li>
                <li class="load-more" @click="nextPage()" v-if="page < paginator.pages">
                    {{t('Load more')}}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faBell} from '@fortawesome/free-solid-svg-icons'
    import Loading from '../core/Components/loading';

    library.add(faBell);

    export default {
        components: {Loading},
        props: {
            count: {
                type: Number,
                required: true,
            },
            vuex: {
                type: String,
                required: true,
            }
        },
        computed: {},
        methods: {
            nextPage() {
                this.page += 1;
                this.loadData();
            },
            open(notification) {
                this.$emit('openNotification', notification);
                this.hideNotifications();
            },
            loadData() {
                this.loading = true;
                this.$store.dispatch('notifications/load', {page: this.page}).then(data => {
                    this.paginator = data.paginator;
                    this.notifications = [...this.notifications, ...data.items];
                    this.firstLoading = false;
                    this.loading = false;
                }).catch(res => {
                    this.firstLoading = false;
                    this.loading = false;
                });
            },
            toggleNotifications() {
                this.opened = !this.opened;
                if (this.opened === true) {
                    this.$emit('opened');
                    this.loadData();
                } else {
                    this.hideNotifications();
                }
            },
            hideNotifications() {
                this.notifications = [];
                this.firstLoading = true;
                this.opened = false;
            }
        },
        data() {
            return {
                page: 1,
                paginator: {},
                notifications: [],
                opened: false,
                firstLoading: true,
                loading: false,
            }
        }
    }
</script>
<style lang="scss">
    .notifications {
        position: relative;

        .notifications-backdrop {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1;
            /*cursor: pointer;*/
        }

        .notifications-content {
            background: #fff;
            position: absolute;
            top: 100%;
            right: 10px;
            border-radius: 3px;
            width: 300px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            z-index: 2;

            -webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
            -moz-box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);

            .notifications-header {
                padding: 8px 13px;
                position: relative;

                .notification-loading-small {
                    position: absolute;
                    top: 8px;
                    right: 20px;
                }
            }

            .notification-loading {
                border-top: 1px solid rgba(0, 0, 0, 0.15);
                padding: 20px 0;
                text-align: center;
            }

            .notifications-list {
                margin: 0;
                padding: 0;
                list-style: none;
                max-height: 400px;
                overflow-x: auto;

                > li {
                    border-top: 1px solid rgba(0, 0, 0, 0.15);
                    padding: 10px 13px 10px 11px;
                    line-height: 20px;
                    font-size: 15px;
                    color: #565a5c;
                    cursor: pointer;
                    border-left: 2px solid #fff;

                    &:hover {
                        border-left-color: #009DFA;
                    }

                    .notifications-list-item {
                        line-height: 17px;
                    }

                    .date {
                        opacity: .7;
                    }

                    &.load-more {
                        border-left-color: #F4F5F7;
                        background: #F4F5F7;
                        text-align: center;

                        &:hover {
                            border-left-color: #F4F5F7;
                        }
                    }
                }
            }
        }

        .btn-notification {
            color: #fff;
            outline: none;
            box-shadow: none;
            position: relative;

            .badge {
                font-weight: normal;
                font-size: 12px;
                padding: 3px;
                border-radius: 50%;
                min-width: 18px;
                position: absolute;
                top: 0;
                right: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/notifications.vue